const initialState = {
  nearest_police: [],
  is_deleted: false,
  interval_ids: []
}

const nearestPoliceData = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_NEAREST_POLICE":
      return { ...state, nearest_police: typeof action?.val === "number" ? [...state.nearest_police, action?.val] : [] }
    case "IS_DELETED_STATE":
      return { ...state, is_deleted: action.val }
    case "ADD_INTERVAL_ID":
      return { ...state, interval_ids: action?.val === "clear" ? [] : [...state.interval_ids, action?.val] }
    default:
      return state
  }
}

export default nearestPoliceData
